<template>
  <span>
    <BotPageTitle />
    <h3
      :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '20px' : '' }"
      style="margin-top: 0; margin-bottom: 20px; padding: 0 15px"
    >
      {{ $t('assistantsList.selectAssistant') }}
    </h3>
    <!-- <div class="md-layout">
      <div class="md-layout-item ml-auto">
        <md-button style="float: right;" class="md-warning">
          <img
            :src="icons.createRobot"
            style="height: 26px; width: 26px; margin-right: 10px;"
          />
          <span style="color: black;">{{
            $t('assistantsList.createAssistant')
          }}</span>
        </md-button>
      </div>
    </div> -->
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>list_alt</md-icon>
            </div>
            <h4 class="title">
              {{ $t('assistantsList.cognitiveAssistantsList') }}
            </h4>
          </md-card-header>
          <md-card-content>
            <md-progress-bar
              v-if="loading"
              class="md-primary"
              md-mode="query"
              style="margin-bottom: 0px"
            ></md-progress-bar>
            <md-table
              :value="queriedData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover"
            >
              <md-table-toolbar>
                <md-field>
                  <label for="pages">{{ $t('assistantsList.perPage') }}</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                      {{ item }}
                    </md-option>
                  </md-select>
                </md-field>

                <md-field>
                  <md-input
                    type="search"
                    class="mb-3"
                    clearable
                    style="width: 200px"
                    :placeholder="$t('assistantsList.search') + '...'"
                    v-model="searchQuery"
                  >
                  </md-input>
                </md-field>
              </md-table-toolbar>

              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell
                  :md-label="$t('assistantsList.assistantName')"
                  md-sort-by="name"
                  >{{ item.name }}</md-table-cell
                >
                <md-table-cell :md-label="$t('assistantsList.channels')">
                  <span style="margin-right: 25px">
                    <img
                      @click="checkChannel('webclient', item, '/canal-web')"
                      :src="icons.world"
                      :style="{
                        filter: hasChannel(item, 'webclientChannels')
                          ? ''
                          : 'grayscale(100%)',
                        cursor: hasChannel(item, 'webclientChannels')
                          ? 'pointer'
                          : '',
                      }"
                      style="height: 26px; width: 26px"
                    />
                    <md-tooltip
                      v-if="hasChannel(item, 'webclientChannels')"
                      md-direction="bottom"
                      >{{$t('assistantList.webChannel')}}</md-tooltip
                    >
                  </span>
                  <span style="margin-right: 25px">
                    <img
                      @click="checkChannel('teams', item, '/microsoft-teams')"
                      :src="icons.teams"
                      :style="{
                        filter: hasChannel(item, 'teamsChannels')
                          ? ''
                          : 'grayscale(100%)',
                        cursor: hasChannel(item, 'teamsChannels')
                          ? 'pointer'
                          : '',
                      }"
                      style="height: 26px; width: 26px"
                    />
                    <md-tooltip
                      v-if="hasChannel(item, 'teamsChannels')"
                      md-direction="bottom"
                      >{{$t('assistantList.teamsChannel')}}</md-tooltip
                    >
                  </span>
                  <span style="margin-right: 25px">
                    <img
                      @click="checkChannel('wpp', item, '/whats-app')"
                      :src="icons.wpp"
                      :style="{
                        filter: hasChannel(item, 'whatsappChannels')
                          ? ''
                          : 'grayscale(100%)',
                        cursor: hasChannel(item, 'whatsappChannels')
                          ? 'pointer'
                          : '',
                      }"
                      style="height: 26px; width: 26px"
                    />
                    <md-tooltip
                      v-if="hasChannel(item, 'whatsappChannels')"
                      md-direction="bottom"
                      >{{$t('assistantList.whatsAppChannel')}}</md-tooltip
                    >
                  </span>
                  <span style="margin-right: 25px">
                    <img
                      @click="
                        checkChannel('messenger', item, '/canal-messenger')
                      "
                      :src="icons.fb"
                      :style="{
                        filter: hasChannel(item, 'fbChannels')
                          ? ''
                          : 'grayscale(100%)',
                        cursor: hasChannel(item, 'fbChannels') ? 'pointer' : '',
                      }"
                      style="height: 26px; width: 26px"
                    />
                    <md-tooltip
                      v-if="hasChannel(item, 'fbChannels')"
                      md-direction="bottom"
                      >{{$t('assistantList.facebookChannel')}}</md-tooltip
                    >
                  </span>
                                 <span style="margin-right: 25px">
                    <img
                      @click="
                        checkChannel('instagram', item, '/canal-instagram')
                      "
                      :src="icons.ig"
                      :style="{
                        filter: hasChannel(item, 'igChannels')
                          ? ''
                          : 'grayscale(100%)',
                        cursor: hasChannel(item, 'igChannels') ? 'pointer' : '',
                      }"
                      style="height: 26px; width: 26px"
                    />
                    <md-tooltip
                      v-if="hasChannel(item, 'igChannels')"
                      md-direction="bottom"
                      >Instagram</md-tooltip
                    >
                  </span>
                  <!-- <span style="margin-right: 25px;">
                    <img
                      @click="checkChannel('telegram', item, '/telegram')"
                      :src="icons.telegram"
                      :style='{ filter: hasChannel(item, "telegramChannels") ? "" : "grayscale(100%)", cursor: hasChannel(item, "telegramChannels") ? "pointer" : "" }'
                      style="height: 26px; width: 26px;"
                    />
                    <md-tooltip v-if='hasChannel(item, "telegramChannels")' md-direction="bottom"
                      >Canal Telegram</md-tooltip
                    >
                  </span> -->
                </md-table-cell>
                <!-- <md-table-cell md-label="Workspace">
                  <v-row no-gutters style="padding: 0; cursor: pointer; justify-content: flex-end!important; margin-right: 25px;">
                    <v-col
                      @click="goToWorkspace(item)"
                      cols="auto"
                      style="align-self: center; text-decoration: underline;"
                    >
                      {{ workspaces[0].name }}
                      <md-tooltip md-direction="bottom"
                        >Visualizar/Editar essa workspace</md-tooltip
                      >
                    </v-col> -->
                <!-- <v-col cols="auto">
                      <md-menu
                        @md-opened="menuWorkspaces = true"
                        @md-closed="menuWorkspaces = false"
                        md-size="huge"
                        md-direction="bottom-end"
                        style="width: 27px;"
                      >
                        <md-button
                          md-menu-trigger
                          class="md-button md-just-icon md-theme-default md-primary"
                          style="
                            height: 27px;
                            min-width: 10px;
                            width: 27px;
                            border-radius: 50%;
                            margin-left: 4px;
                          "
                          ><md-icon style="font-size: 17px;">create</md-icon>
                          <md-tooltip md-direction="bottom"
                            >Mudar workspace selecionada</md-tooltip
                          >
                        </md-button>
                        <md-menu-content>
                          <md-menu-item
                            v-for="workspace in workspaces"
                            :key="workspace.id"
                            v-ripple
                            @click="selectWorkspace(item, workspace)"
                          >
                            {{ workspace.name }}
                          </md-menu-item>
                        </md-menu-content>
                      </md-menu>
                    </v-col> -->
                <!-- </v-row>
                </md-table-cell> -->
                <!-- <md-table-cell :md-label="$t('assistantsList.configure')">
                  <span style="margin-right: 25px;">
                    <img
                      @click="goToWorkspace(item)"
                      :src="icons.robot"
                      style="height: 26px; width: 26px; cursor: pointer;"
                    />
                    <md-tooltip md-direction="bottom"
                      >Visualizar/Editar workspace ativa</md-tooltip
                    >
                  </span>
                  <span>
                    <img
                      @click="configureAssistant(item)"
                      :src="icons.gear"
                      style="height: 26px; width: 26px; cursor: pointer;"
                    />
                    <md-tooltip md-direction="bottom"
                      >Configurações do assistente</md-tooltip
                    >
                  </span>
                </md-table-cell> -->
                <!-- <md-table-cell :md-label="$t('assistantsList.test')">
                  <img
                    :src="icons.test"
                    style="
                      height: 26px;
                      width: 26px;
                      cursor: pointer;
                      margin-right: 35px;
                    "
                  />
                </md-table-cell> -->
              </md-table-row>
            </md-table>
            <div class="footer-table md-table">
              <table>
                <tfoot>
                  <tr>
                    <th
                      v-for="item in footerTable"
                      :key="item.name"
                      class="md-table-head"
                    >
                      <div
                        class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">
                          {{ item }}
                        </div>
                      </div>
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class="">
              <p class="card-category">
                {{
                  $t('assistantsList.showingItems', {
                    from: from + 1,
                    to: to,
                    total: total,
                  })
                }}
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </pagination>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </span>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
// import assistentesList from './data/assistentesList'
import Fuse from 'fuse.js'
import Swal from 'sweetalert2'
import { mapFields } from 'vuex-map-fields'
import BotPageTitle from '@/components/BotPageTitle.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    Pagination,
    BotPageTitle
  },
  computed: {
    ...mapFields('selectedAssistant', {
      assistantId: 'assistantId',
      workspaceId: 'workspaceActiveId'
    }),
    ...mapGetters('workspaces', ['workspaces', 'active']),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData () {
      let result = this.tableData
      if (this.searchedData.length > 0) {
        result = this.searchedData
      }
      return result.slice(this.from, this.to)
    },
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length
    }
  },
  data () {
    return {
      prevRoute: null,
      loading: true,
      currentSort: 'name',
      currentSortOrder: 'asc',
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      footerTable: [
        this.$t('assistantsList.assistantName'),
        this.$t('assistantsList.channels')
        // 'Workspace'
        // this.$t('assistantsList.configure')
        // this.$t('assistantsList.test')
      ],
      searchQuery: '',
      propsToSearch: ['name'],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      icons: {
        createRobot: require('../../public/img/create-robot-icon.png'),
        world: require('../../public/img/table-icon-world.png'),
        // worldDisabled: require('../../public/img/table-icon-world-disabled.png'),
        teams: require('../../public/img/table-icon-teams.png'),
        fb: require('../../public/img/table-icon-fb.png'),
        fbDisabled: require('../../public/img/table-icon-fb-disabled.png'),
        wpp: require('../../public/img/table-icon-wpp.png'),
        ig: require('../../public/img/table-icon-instagram.jpg'),
        igDisabled: require('../../public/img/table-icon-instagram-disabled.png'),
        // wppDisabled: require('../../public/img/table-icon-wpp-disabled.png'),
        telegram: require('../../public/img/table-icon-telegram.png'),
        robot: require('../../public/img/table-icon-robot.png'),
        gear: require('../../public/img/table-icon-gear.png')
        // test: require('../../public/img/table-icon-testar.png')
      },
      menuWorkspaces: false
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  methods: {
    customSort (value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort
        if (this.currentSortOrder === 'desc') {
          return a[sortBy].localeCompare(b[sortBy])
        }
        return b[sortBy].localeCompare(a[sortBy])
      })
    },
    hasChannel (item, channel) {
      if (item[channel]?.length > 0) {
        return true
      }
      return false
    },
    checkChannel (channel, item, channelPath) {
      let prop
      switch (channel) {
        case 'webclient':
          prop = 'webclientChannels'
          break
        case 'teams':
          prop = 'teamsChannels'
          break
        case 'wpp':
          prop = 'whatsappChannels'
          break
        case 'telegram':
          prop = 'telegramChannels'
          break
        case 'messenger':
          prop = 'fbChannels'
          break
        case 'instagram':
          prop = 'igChannels'
          break
      }
      if (item[prop]?.length > 0) {
        if (prop === 'fbChannels') {
          this.goTo(channelPath)
        }
        if (prop === 'igChannels') {
          this.goTo(channelPath)
        }
        if (prop === 'webclientChannels') {
          this.assistantId = item.id
          this.workspaceId = this.workspaces[0].id
          this.goTo(channelPath)
        }
        if (prop === 'whatsappChannels') {
          this.goTo(channelPath)
        }
        if (prop === 'teamsChannels') {
          this.goTo(channelPath)
        }
      }
    },
    fireAlert (channel) {
      Swal.fire({
        text: this.$t('assistantList.settingsForThisChannelAreCurrentlyUnavailable'),
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
    },
    goTo (path) {
      this.$router.push(path)
    },
    goToWorkspace (item) {
      // console.log(`gotowokr`, item)
      this.workspaceId = this.workspaces[0].id
      this.assistantId = item.id
      if (!!this.active && this.workspaces[0].id === this.active.id) {
        this.$store.commit('snapshots/setAppliedSnapshot', null)
      }
      this.$router.push('/snapshots')
    }
    // selectWorkspace (item, workspace) {
    //   console.log(`select workspaces for assistant`)
    //   if (item !== this.assistantData) {
    //     item.workspace.id = workspace.id
    //     item.workspace.name = workspace.name
    //   } else {
    //     this.assistantWorkspace = workspace.id
    //     this.assistantData = item
    //   }
    // }
    // selectAssistant (item) {
    //   console.log(item)
    //   this.assistantWorkspace = item.workspace.id
    //   this.assistantData = item
    // }
    // configureAssistant (item) {
    //   console.log(item)
    //   this.assistantWorkspace = item.workspace.id
    //   this.assistantData = item
    //   this.$router.push('/settings')
    // }
  },
  created () {
    // console.log('created da workspaces.vue')
    this.$store.dispatch('workspaces/populate')
  },
  mounted () {
    // Get assistants
    this.$axios
      .get('/assistant-configs')
      .then((response) => {
        this.loading = false
        this.tableData = response.data.data
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: this.$t('assistantList.error'),
          html: `${this.$t('assistantList.unableToAccessWizardsList')} <br> ${error}`
        })
        this.loading = false
      })
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ['name'],
      threshold: 0.3
    })
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery (value) {
      let result = this.tableData
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery)
      }
      this.searchedData = result
    }
  }
}
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
